import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState: { latestAchievementType: any } = {
	latestAchievementType: null,
};

export const achievementsSlice = createSlice({
	name: 'achievements',
	initialState,
	reducers: {
		setLatestAchievementType: (state, action: { payload: any }) => {
			state.latestAchievementType = action.payload;
		},
	},
});

export const { setLatestAchievementType } = achievementsSlice.actions;

export const useLatestAchievementTypeSelector = () =>
	useSelector((state: any) => state.achievements.latestAchievementType);
